import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../components/internal/Icon.js';

function EllipsisIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, {
    fill: "currentColor",
    ...props,
    children: [
      /* @__PURE__ */ jsx("circle", {
        cx: 5,
        cy: 10,
        r: 0.75
      }),
      /* @__PURE__ */ jsx("circle", {
        cx: 10,
        cy: 10,
        r: 0.75
      }),
      /* @__PURE__ */ jsx("circle", {
        cx: 15,
        cy: 10,
        r: 0.75
      })
    ]
  });
}

export { EllipsisIcon };
//# sourceMappingURL=Ellipsis.js.map
